export const getHighResUrl = (url: string) => {
	return url.replace(
		ENV.AWS_S3_URL + '/photo',
		ENV.AWS_CLOUDFRONT_URL + '/high-res-photo',
	)
}
export const getMediumResUrl = (url: string) => {
	return url.replace(
		ENV.AWS_S3_URL + '/photo',
		ENV.AWS_CLOUDFRONT_URL + '/medium-res-photo',
	)
}
export const getLowResUrl = (url: string) => {
	return url.replace(
		ENV.AWS_S3_URL + '/photo',
		ENV.AWS_CLOUDFRONT_URL + '/low-res-photo',
	)
}

export function CloudFrontImage({
	work,
	className = '',
	watermarked = false,
	loading = 'lazy',
	sizes = '30vw',
}: {
	work: {
		id: string | null
		name: string | null
		originalAssetUrl: string
		user: {
			name: string | null
		}
	}
	sizes?: string
	className?: string
	watermarked?: boolean
	loading?: 'eager' | 'lazy'
}) {
	const highResUrl = getHighResUrl(work.originalAssetUrl)
	const lowResUrl = getLowResUrl(work.originalAssetUrl)
	let workName =
		work.name && work.name.trim() !== '' ? work.name : 'Untitled Work'
	return (
		<img
			alt={`${workName} by ${work.user.name}`}
			title={`${workName} by ${work.user.name}`}
			src={watermarked ? highResUrl : lowResUrl}
			loading={loading}
			sizes={sizes}
			className={`pointer-events-none h-full w-full max-w-[2160px] object-contain object-center ${className}`}
		/>
	)
}
